module.exports = __webpack_public_path__ + "img/phone.6e3895ff.svg";